import { render } from "./OphthalmologyClinicPage.vue?vue&type=template&id=579db1e8"
import script from "./OphthalmologyClinicPage.vue?vue&type=script&lang=js"
export * from "./OphthalmologyClinicPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__